import React from 'react';
import ReactDOM from 'react-dom';

const ConfirmModal = ({
  show,
  title,
  titleIcon,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  confirmVariant = 'danger',
  children,
  pending = false,
}) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.65)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
      onClick={(e) => {
        if (pending) return;
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '460px',
          background: 'var(--glass-bg-dark)',
          border: '1px solid var(--glass-border)',
          borderRadius: '16px',
          boxShadow: '0 24px 60px rgba(0,0,0,0.6)',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, var(--primary), var(--accent))',
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h5 style={{ margin: 0, color: '#fff', fontWeight: 700, fontSize: '1rem' }}>
            {titleIcon && <i className={`bi ${titleIcon} me-2`}></i>}
            {title}
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onCancel}
            disabled={pending}
            aria-label="Close"
            style={{ opacity: 0.8 }}
          />
        </div>

        <div style={{ padding: '20px', color: 'var(--text-primary)' }}>
          {children}
        </div>

        <div
          style={{
            padding: '12px 20px 20px',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            borderTop: '1px solid var(--glass-border)',
          }}
        >
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={pending}>
            <i className="bi bi-x-circle me-2"></i>Cancel
          </button>
          <button
            type="button"
            className={`btn btn-${confirmVariant}`}
            onClick={onConfirm}
            disabled={pending}
          >
            {pending ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Please wait
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
